import { useState, useEffect } from 'react';
import axios from 'axios';
import { Client } from '../types/client';
import { API_ENDPOINTS } from '../config/api';

export const useClientData = () => {
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        setLoading(true);
        
        // Fetch clients from MongoDB through our API
        const response = await axios.get<Client[]>(
          `${API_ENDPOINTS.CLIENTS}?status=active`,
          {
            headers: {
              'Content-Type': 'application/json',
              // Add any necessary auth headers
            }
          }
        );
        
        // Sort by name
        const sortedClients = response.data.sort((a, b) => 
          a.name.localeCompare(b.name)
        );
        
        setClients(sortedClients);
        setError(null);
      } catch (err) {
        console.error('Error fetching clients:', err);
        setError('Failed to load clients. Please try again.');
        setClients([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []); // Empty dependency array means this runs once on mount

  const refreshClients = async () => {
    setLoading(true);
    try {
      const response = await axios.get<Client[]>(
        `${API_ENDPOINTS.CLIENTS}?status=active`
      );
      
      const sortedClients = response.data.sort((a, b) => 
        a.name.localeCompare(b.name)
      );
      
      setClients(sortedClients);
      setError(null);
    } catch (err) {
      console.error('Error refreshing clients:', err);
      setError('Failed to refresh clients. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    clients,
    loading,
    error,
    refreshClients
  };
}; 